// src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "swiper/css";
import "swiper/scss/navigation";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/grid";

import i18n from "./i18n";
import VueLeaflet from '@vdcrea/vue-leaflet';
import VueAwesomePaginate from "vue-awesome-paginate";
import '@vdcrea/vue-leaflet/dist/vue-leaflet.css';

import { Vue3Toastify, toast } from 'vue3-toastify';
import CanvasJSChart from '@canvasjs/vue-charts';
import { quillEditor } from 'vue3-quill';

// import echo from './plugins/echo';

import "./assets/styles/tailwind.css";

// --- axios defaults ---
const lang = localStorage.getItem("lang") || "ru";

axios.defaults.baseURL = process.env.VUE_APP_API_URL || "http://localhost:8090/api";
// для Vite : axios.defaults.baseURL = import.meta.env.VITE_API_URL || "http://localhost:8080/api";

axios.defaults.params = { lang };

// --- create app (только один раз!) ---
const app = createApp(App);

// --- register global properties (доступно в компонентах как this.$echo / this.$toast) ---
// app.config.globalProperties.$echo = echo;

// --- use plugins ---
app
    .use(store)
    .use(router)
    .use(i18n)
    .use(CanvasJSChart)
    .use(quillEditor)
    .use(VueLeaflet)
    .use(VueAwesomePaginate)
    .use(VueViewer)
    .use(Vue3Toastify, { autoClose: 3000 });

// --- mount once ---
app.mount("#app");
